import util from "./Helpers";

const gqlHelper = {
  genericGQLQuery: async (query, variables) => {
    let apiIndex = util.isLocalhost()
      ? "http://localhost:9393/auth/graphql"
      : `${util.getCurrentHost()}/auth/auth/graphql`;

    const opts = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query, variables }),
    };

    const data = await fetch(apiIndex, opts)
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        return data;
      });

    return data;
  },
};

export default gqlHelper;
